import { Component, AfterViewInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Validators, FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { ViewController, NavParams, IonicFormInput } from 'ionic-angular';

import { SessionService } from '../../services/session.service';
import { AdminService } from '../../services/admin.service';
import { RecommendationService } from '../../services/recommendation.service';
import { RegionService } from '../../services/region.service';
import { NetworkStatusService } from '../../services/network-status.service';
import { UtilityService } from '../../services/utility.service';

interface FormFormControlObject {
  [key: string]: FormControl;
}

@Component({
  selector: 'email-customer-page',
  templateUrl: 'email-customer.html',
})
export class EmailCustomerPage implements AfterViewInit {
  @ViewChild('pdfBody', { read: ViewContainerRef })
  pdfBody: ViewContainerRef;

  @ViewChild('emailBody', { read: ViewContainerRef })
  emailBody: ViewContainerRef;

  private customerFormControlObject: FormFormControlObject;
  customerFormObject: FormGroup;
  formIsReady: boolean;
  wait: boolean;

  networkOnline: boolean;

  clearOldData: boolean;
  constructor(
    private formBuilder: FormBuilder,
    private recommendationService: RecommendationService,
    public regionService: RegionService,
    public sessionService: SessionService,
    public adminService: AdminService,
    public viewCtrl: ViewController,
    public networkService: NetworkStatusService,
    private navParams: NavParams
  ) {
    this.clearOldData = this.navParams.get('clearOldData');
    this.networkService.online$.subscribe((res) => {
      this.networkOnline = res;
      if (!this.networkOnline && this.wait) {
        this.viewCtrl.dismiss(false);
      }
    });
  }

  close(): void {
    this.viewCtrl.dismiss();
  }

  send(): void {
    console.log('send email');
    this.wait = true;
    const pdfBody: string = this.pdfBody.element.nativeElement.innerHTML;
    this.recommendationService.uploadRecommendation(pdfBody).subscribe(() => {
      // wait for the file url to write to the dom
      setTimeout(() => {
        const emailBody: string = this.emailBody.element.nativeElement.innerHTML;
        this.emailActionListener();
        this.recommendationService.email(emailBody).subscribe(() => {
          this.wait = false;
          this.viewCtrl.dismiss(true);
        });
      }, 200);
    });
  }

  private emailActionListener() {
    window.addEventListener('didReceiveEmailState', (data: any) => {
      console.log('didReceiveEmailState', data.detail.results);

      if (data.detail.results.emailState >= 0) {
        this.wait = false;
        this.viewCtrl.dismiss(true);
      }
    });
  }

  // private updateForm(): void {
  //   setTimeout(() => {
  //     const valid: boolean = this.customerFormObject.valid;
  //   }, 100);
  // }

  private generateFormControlObj(): FormFormControlObject {
    const utilityService = new UtilityService();
    const customerFormControlObject: FormFormControlObject = {};

    function buildFormControl(field: any): void {
      const validators: any[] = [];
      if (field.required) {
        validators.push(Validators.required);
        validators.push(utilityService.validateEmail);
      }
      customerFormControlObject[field.name] = new FormControl(field.model, validators);
    }

    this.sessionService.customer.forEach((field: any) => {
      buildFormControl(field);
      customerFormControlObject[field.name].valueChanges.subscribe((value: any) => {
        field.model = value;
        if (field.type === 'toggle') {
          if (field.name === 'sendDoctor') {
            // (value) ? customerFormControlObject.doctor.disable({ emitEvent: true }) : customerFormControlObject.doctor.disable();
            if (value.length === 0) {
              this.sessionService.doctor.disabled = false;
            } else {
              this.sessionService.doctor.disabled = !value;
            }
            if (value) {
              customerFormControlObject.doctor.disable({ emitEvent: true, onlySelf: true });
            }

            if (this.customerFormObject && this.customerFormObject.controls) {
              if (!this.sessionService.doctor.disabled) {
                this.customerFormObject.controls['doctor'].enable();
              }
              this.customerFormObject.controls['doctor'].setValidators(
                this.sessionService.doctor.disabled ? [] : [Validators.required, utilityService.validateEmail]
              );
              this.customerFormObject.controls['doctor'].updateValueAndValidity();
            } else {
              customerFormControlObject.doctor.setValidators(
                this.sessionService.doctor.disabled ? [] : [Validators.required, utilityService.validateEmail]
              );
            }
          }
        }
        // this.updateForm();
      });
    });

    if (!this.sessionService.doctor.model) {
      this.sessionService.doctor.model = this.adminService.email.model;
    }
    this.sessionService.customer.forEach((field: any) => {
      this.clearOldData
        ? customerFormControlObject[field.name].setValue(field.name === 'sendDoctor' ? false : '')
        : customerFormControlObject[field.name].setValue(field.model);
    });

    return customerFormControlObject;
  }

  private buildForm(): void {
    this.customerFormControlObject = this.generateFormControlObj();
    this.customerFormObject = this.formBuilder.group(this.customerFormControlObject);

    setTimeout(() => {
      this.formIsReady = true;
    }, 300);
  }

  submit(formValues: any, valid: boolean): void {
    console.log(formValues, valid);
  }

  ngAfterViewInit(): void {
    this.buildForm();
  }
}



// WEBPACK FOOTER //
// ./src/pages/email-customer/email-customer.ts